import React from "react";

function LeftArrow(props) {
  return (
    <svg
      width={props.small ? "15" : "25"}
      height={props.small ? "23" : "43"}
      viewBox="0 0 28 46"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M27.4153 44.5L1.5 23.0922L27.4153 1.49166"
        stroke="black"
        strokeWidth="1.32333"
      />
    </svg>
  );
}

export default LeftArrow;
